
const routes = [
  {
    path: '/businessSubscription',
    name: 'businessSubscription',
    meta: {
      title: '商机订阅',
      icon: 'icon-guanyu',
      noAuth: true
    },
    component: () => import('@main/modules/businessSubscription/views/businessSubscription.vue')
  }
]
export default routes
